import { LiabilityFormData, LiabilityTypeLabelBuilder } from './types';
import { FIELDS } from '../../../../../../fields/types';

export class CreditCommitmentLabelBuilder implements LiabilityTypeLabelBuilder {
  private labels: { [key in keyof LiabilityFormData]: string };

  constructor() {
    this.labels = {
      [FIELDS.EXPENDITURE_ID]: '',
      [FIELDS.EXPENDITURE_TYPE]: 'Type',
      [FIELDS.EXPENDITURE_BALANCE]: 'Card balance',
      [FIELDS.EXPENDITURE_AMOUNT]: 'Payment amount',
      [FIELDS.EXPENDITURE_END_DATE]: 'End date',
      [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BEFORE_LOAN]: 'Cleared before loan completes',
      [FIELDS.EXPENDITURE_WILL_BE_CLEARED_BY_LOAN]: 'Cleared by the LiveMore loan ',
      [FIELDS.EXPENDITURE_CREDIT_LIMIT]: 'Card limit',
      [FIELDS.EXPENDITURE_DESCRIPTION]: 'Description',
      [FIELDS.EXPENDITURE_FREQUENCY]: 'Payment frequency',
      [FIELDS.EXPENDITURE_TOTAL_NUMBER_OF_PROPERTIES]: 'Total no. of properties in portfolio',
    };
  }

  getLabel(field: keyof LiabilityFormData): string {
    return this.labels[field];
  }

  setType(label: string) {
    this.labels.type = label;
  }

  setAmount(label: string) {
    this.labels.amount = label;
  }

  setCreditCardBalance(label: string) {
    this.labels.balance = label;
  }

  setIsClearedBeforeLoanCompletes(label: string) {
    this.labels.willBeClearedBeforeLoan = label;
  }

  setEndDate(label: string) {
    this.labels.endDate = label;
  }

  setCreditLimit(label: string): void {
    this.labels.creditLimit = label;
  }

  setDescription(label: string): void {
    this.labels.description = label;
  }

  setFrequency(label: string): void {
    this.labels.frequency = label;
  }

  setId(label: string): void {
    this.labels.id = label;
  }

  setIsClearedByLoanCompletes(label: string): void {
    this.labels.willBeClearedByLoan = label;
  }

  setTotalNumberOfProperties(label: string): void {
    this.labels.totalNumberOfProperties = label;
  }
}
